var _style, _path, _polyline, _polyline2, _path2, _path3, _polyline3, _path4, _path5, _path6, _path7, _defs, _g, _g2, _g3, _g4, _path8, _g5, _g6, _path9, _circle, _g7, _path10, _ellipse, _g8, _path11, _path12, _path13, _path14, _path15, _path16, _g9, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShineInTechPond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1457.8 1256.7",
    style: {
      enableBackground: "new 0 0 1457.8 1256.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#412412;stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#41AAE0;stroke-width:6.6305;stroke-miterlimit:10;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:#C3D4D8;}\r\n\t.st4{fill:url(#SVGID_2_);}\r\n\t.st5{fill:none;stroke:#41AAE0;stroke-width:13;stroke-miterlimit:10;}\r\n\t.st6{fill:url(#SVGID_4_);}\r\n\t.st7{clip-path:url(#SVGID_5_);}\r\n\t.st8{fill:none;stroke:#31C4F3;stroke-width:7;stroke-miterlimit:10;}\r\n\t.st9{fill:none;}\r\n\t.st10{fill:#EF4924;stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st11{fill:#FFFFFF;}\r\n\t.st12{fill:#E4AC23;}\r\n\t.st13{fill:#FFFFFF;stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st14{fill:#1F1612;}\r\n\t.st15{fill:#D69328;}\r\n\t.st16{fill:#E4AC23;stroke:#1F130C;stroke-width:5;stroke-miterlimit:10;}\r\n\t.st17{fill:url(#SVGID_6_);}\r\n\t.st18{fill:#9C9282;}\r\n\t.st19{opacity:0.7;}\r\n\t.st20{fill:#C3B9A8;}\r\n\t.st21{fill:url(#SVGID_7_);}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1105.3,333.5c16.8-5.2,29-20.9,29-39.4c0-22.8-18.5-41.3-41.3-41.3c-7.3,0-12.4,0.8-20.1,4.9 c-0.9,0.6-1.8,1.2-2.6,1.8c-6.4,4.2-11.6,10.2-14.8,17.3c-6.9-5.6-14.1-10.7-21.6-15.3c-1.7-0.1-3.4-0.2-5.1-0.4 c1.2-1.1,2.4-2.2,3.6-3.3c31.3-27.2,84.5-41.3,84.5-41.3c-48.7-11.8-93.2-12.3-132.6-6.5c19.5-20.8,40.2-35.5,40.2-35.5 c-78,9.4-136.7,41-179.3,76.1c-0.5-2.6-1.3-5.1-2.3-7.4c-0.9-2.3-2-4.5-3.4-6.6c0,0.1-0.1,0.2-0.1,0.3c-6.4-9-16.9-14.9-28.8-14.9 c-19.4,0-35.2,15.8-35.2,35.2c0,3.8,0.6,7.5,1.8,11c-0.1-0.1-0.2-0.2-0.2-0.2c0.7,1.9,1.5,3.7,2.4,5.4c3.6,7,9.5,12.6,16.7,15.9 c-37.6,33.8-67.1,81-83.1,136.2c-4.4,15-7.7,30.6-9.9,46.6c12.4,11.4,37.2,32.5,67.5,50l1.6,0.9c24.8,14,53,25.4,81.1,26.9 c78.6,4.1,165.3-41.1,192.1-66.4c24.7-23.3,92.5-20.3,103.3-19.6C1143.9,415.1,1128.7,370.4,1105.3,333.5z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "1192.8,563.9 1192.8,752.3 1302.2,690.8 1302.2,805.1 1103.2,920.8 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "260.1,227.7 260.1,353.7 260.1,410.1 329.7,451.6 329.7,393.9 370.3,417.3 369.9,512.7 330.5,490.3  329.8,577.4 369.5,599.9 369.2,669.9 530.2,761.6 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 177.2841,
    y1: 181.5213,
    x2: 451.8794,
    y2: 181.5213
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M194.9,103.6c0,36.5,16.4,76.2,37.8,94c2.4,2,4.7,3.7,7.2,5.1l147.8,113.6l43.2-10.4 c12.4-2.9,20.9-18.9,21-42.9c0.1-33.8-16.7-70.9-37.5-82.9c-3.8-2.2-7.5-3.4-11-3.7c0,0-10.1,1.5-18.2,3.6 c-0.2-49.2-27.3-108-60.7-127.3c-8.5-4.9-16.6-6.7-24-5.9l-40.5,10c-3.8,6,8.9,20.7,6.8,29.4c-7.5-13.4-16.8-24.2-26.9-30 c-7.2-4.2-14-5.3-20.1-3.9l-41.7,10.1C172.8,71.4,194.9,87.8,194.9,103.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M152.3,113.9c0,36.5,16.4,76.2,37.8,94c2.4,2,4.7,3.7,7.2,5.1l174.3,100c20.8,11.9,37.6-5.9,37.7-39.7 c0.1-33.8-16.7-70.9-37.5-82.9c-11.7-6.7-22.2-4.1-29.1,5.7c-0.4-54.4-27.4-113.8-60.8-133.1c-26.7-15.4-49.4-0.5-57.7,33.6 c-7.5-13.4-16.8-24.2-26.9-30C172.5,52.2,152.3,73.4,152.3,113.9z"
  }))), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "534.2,428.2 534.2,509.7 424.8,448.2 424.8,669.4 623.8,785.1 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 472.4784,
    y1: 389.5059,
    x2: 651.1639,
    y2: 389.5059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M651.2,445.3c0,11-4.3,18.4-11.1,21.2l-24.2,10.3c-2.9-0.7,6.2-11.7,2.9-13.5l-98.9-57.1 c-17.9-10.3-32.4-35.1-32.4-55.3c0-5.3-16.7-6.6-14.9-10.2l21.4-8.1c5.7-5.3,14.8-5.8,25-0.2c0.8-8.4-12-12.2-8-17.2l26.5-11.9 c8.7-2.3,21.6-0.5,33.2,6.2c27,15.6,49.1,51.6,51.7,82.8C638.6,403.7,651.2,426.4,651.2,445.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M625.7,456.1c0,20.2-14.5,28.3-32.4,17.9l-98.9-57.1c-17.9-10.3-32.4-35.1-32.4-55.3c0-19.9,14-28,31.5-18.5 c2.7-28,24.9-38.3,51.7-22.8c27,15.6,49.1,51.6,51.7,82.8C613.2,414.5,625.7,437.3,625.7,456.1z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M778.2,791.6c125.2,19.3,460.6,0.7,421.9,149.2c-48.9,187.8-368.6,415-744.3,122.8 c-348.4-271-119-458.5,26.2-458.5C696.7,605,653.1,772.3,778.2,791.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.627,
    y1: 904.2363,
    x2: 1203.2717,
    y2: 904.2363
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M778.2,791.6c125.2,19.3,460.6,0.7,421.9,149.2c-48.9,187.8-368.6,415-744.3,122.8 c-348.4-271-119-458.5,26.2-458.5C696.7,605,653.1,772.3,778.2,791.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M778.2,791.6c125.2,19.3,460.6,0.7,421.9,149.2c-48.9,187.8-368.6,415-744.3,122.8 c-348.4-271-119-458.5,26.2-458.5C696.7,605,653.1,772.3,778.2,791.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "435.7,458.6 1084,830.2 1084.2,897.9 1137.4,929.2 1211.9,887.8 1229,877.9 1258.3,894.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "1253.1,861.4 1226,845.2 1082.6,927.4 1033.1,900 1153.4,832.5 900.2,687 941.7,661.7 911.1,644.7  880.6,661.8 850.9,644.7 911.7,609.6 881,592.6 791.4,644.4 612,541.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "631.5,521.3 797.4,616.8 887.6,564.8 952.3,601.6 921.9,619.5 982.4,653.7 940.8,678.9  1194.1,824.5 1219.4,809.3 1272.4,839.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "507.1,515.6 640.4,592.6 608.4,608.9 670.5,644.7 699.9,627 731.2,645.1 700.5,662.1 881.6,766.6  882.3,836.4 1121.6,975 1218.5,921.3 1461.1,1053.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "340.3,454.8 582,592.4 550,608.7 857.3,786.1 858,855.9 1105.9,1001.5 1210,944.8 1467.5,1090  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "1402.9,1188.2 1212.5,1076.6 1211.9,1014 1185.1,997.9 1185.1,1029.2 1129.9,997.6 1132,1059.1  811.6,874.6 814.8,805.8 395.1,563.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "1343,1219.6 1169,1121.4 1114.8,1153.3 682.7,900.8 738.4,869.8 552.8,762.4 518.6,781.1 398.9,712  398.3,676.9 54.2,478.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "1369.6,1215.7 1172.3,1103.5 1118,1135.4 719.9,902.8 775.6,871.7 471.7,696.3 471.7,733.1  429.6,709.5 429,659.9 223.9,541.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "-85.6,581.7 743.7,1057.1 743.9,1124.8 797.1,1156.1 871.5,1114.7 888.6,1104.9 1174.8,1266.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "1210,1266.1 885.7,1072.1 742.2,1154.3 692.8,1126.9 813.1,1059.4 559.8,913.9 601.4,888.6  570.7,871.6 540.3,888.7 510.6,871.6 571.3,836.5 540.7,819.5 451,871.3 -69,573  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "-54.4,549.4 457.1,843.7 547.3,791.7 612,828.5 581.5,846.4 642,880.6 600.5,905.8 853.7,1051.4  879,1036.2 1272.4,1259.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "-97.5,590 300,819.5 268.1,835.8 330.1,871.6 359.6,853.9 390.9,872 360.2,889 541.3,993.5  541.9,1063.3 781.3,1202 866,1154.9 1060.4,1271.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "-124.6,610.8 241.7,819.3 209.7,835.6 517,1013 517.7,1082.9 765.6,1228.5 912.9,1148.1  1125,1271.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "909,1325.1 872.2,1303.5 871.6,1241 844.8,1224.8 844.8,1256.1 789.5,1224.5 791.6,1286  471.2,1101.5 471.2,1052.9 51.5,810.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "1002.7,1446.6 828.7,1348.3 774.4,1380.2 342.4,1127.7 398.1,1096.7 212.4,989.3 178.3,1008  58.6,938.9 58,903.8 -61.7,834.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st8",
    points: "1029.3,1442.6 831.9,1330.4 777.7,1362.3 379.6,1129.7 435.3,1098.7 131.3,923.2 131.3,960  89.3,936.4 88.7,886.8 -116.4,768.4  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_332_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_334_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_359_",
    className: "st9",
    d: "M772,522.8c-0.5-0.3-1-0.6-1.6-0.9c-1-3.9-1.6-6.1-1.6-6.1S770,518.3,772,522.8z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_40_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_329_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_354_",
    className: "st0",
    d: "M1008.1,756.4c-6.8,3.6-14.2,5-21.3,4.2c-11.1-1.2-21.4-7.6-27.3-18c-2.3-4.1-5-7.9-8.1-11.5 l85.4,6.8C1027.6,744.8,1018,751,1008.1,756.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_42_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_344_",
    className: "st0",
    d: "M845.6,722.6c-2.4,2-4.6,4.2-6.8,6.5c-8.1,8.9-19.6,12.8-30.7,11.6c-7-0.8-13.7-3.6-19.4-8.5 c-5.6-4.8-10.9-10-16-15.4L845.6,722.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M1148.4,463.6c-7.7-0.5-44.6-2.1-74,5.5l0,0c-11.7,3-22.2,7.5-29.2,14.1c-8.7,8.2-23.6,18.4-42.5,28.4 c-39.5,21-96.5,40.8-149.7,38c-26-1.4-52.2-11.3-75.6-23.9c-1.9-1-31.3-19-41.5-26.6l0,0c-14.4-10.6-25.9-20.6-33.1-27.3 c-0.5,3.3-0.9,6.6-1.3,9.9c-3.7,33.2,4.8,95.8,7.9,113.8l0,0c0,0,0,0.1,0.1,0.4c0.4,2.5,0.8,4,0.9,4.5c0.8,2.1,1.6,4.3,2.6,6.5 c0,0,0.4,2.1,1.2,5.7l2.1-11.2l-2.1,11.2c2.9,12.1,11.2,41.3,28.6,65.2c0.1,0.2,0.3,0.3,0.4,0.5c8.7,14,18.6,26.8,29.5,38.4 l72.9,5.8c15.2-13,35.5-19.9,57-17.5c19.8,2.2,36.8,11.9,48.8,26l85.4,6.8c20-15,53.6-54.9,53.5-54.9c-1.1,0.3,20.1-25.3,28.4-51.4 c0,0,0,0,0,0c2.5-6.4,5.5-14.6,8.7-23.6v0c8.5-24.4,18.1-55.5,20.4-76.3C1150.4,508.4,1150.5,485.6,1148.4,463.6z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_25_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_26_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_35_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st11",
    d: "M874.6,464c-1-0.1-2-0.1-2.9-0.2c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0 C872.5,463.9,873.6,464,874.6,464z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_306_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    className: "st12",
    d: "M826.5,255.4c0,0.7,0,1.5-0.1,2.2c-1,9.1-9.2,15.6-18.3,14.6c-0.4-0.1-0.9-0.1-1.3-0.2 C813.8,267.1,820.6,261.7,826.5,255.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_298_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_282_",
    className: "st13",
    d: "M871.2,472.8l-3.8,34c-0.9,7.9,4,14.9,11,15.7l18.8,2.1c5.1,0.6,10.1-2.4,12.6-7.5 c3.3-6.6,6-13.7,8.1-21.2c-13.5-2-26.3-7-37-14.8C877.4,478.5,874.2,475.7,871.2,472.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_32_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_427_",
    className: "st13",
    d: "M934.4,400.6c3,2.8,6.5,5,10.2,6.8c2.1,0.6,4.2,1,6.4,1.3c21.4,2.4,40.6-13.8,41.5-35.7 c0.8-18.5-12.4-35-30.6-38.3c-21.6-3.9-41.6,11.2-44,32.7c-1,9,1.3,17.7,5.9,24.7C927.3,394.5,930.8,397.3,934.4,400.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_281_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_423_",
    className: "st13",
    d: "M802,392c2.2,0.2,4.4,0.3,6.5,0.1c4-0.9,7.9-2.3,11.5-4.4c4.2-2.4,8.2-4.4,12.1-6 c6.1-5.8,10.2-13.8,11.2-22.8c2.3-20.5-12.5-39-33.1-41.3c-20.5-2.3-39,12.5-41.3,33C766.7,371.2,781.5,389.8,802,392z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_229_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_30_",
    className: "st14",
    d: "M795.5,388.9c10.3,1.1,19.5-6.3,20.7-16.5c1.1-10.3-6.3-19.5-16.5-20.7 c-1.4-0.2-2.8-0.1-4.2,0c3.4,1.3,5.7,4.8,5.3,8.6c-0.5,4.5-4.6,7.8-9.1,7.3c-4.5-0.5-7.8-4.6-7.3-9.1c0.1-0.6,0.2-1.2,0.4-1.8 c-3.1,2.9-5.2,6.9-5.7,11.5C777.8,378.5,785.2,387.7,795.5,388.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_228_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_28_",
    className: "st14",
    d: "M944.5,405.5c10.3,1.1,19.5-6.3,20.7-16.5c1.1-10.3-6.3-19.5-16.5-20.7 c-1.4-0.2-2.8-0.1-4.2,0c3.4,1.3,5.7,4.8,5.3,8.6c-0.5,4.5-4.6,7.8-9.1,7.3c-4.5-0.5-7.8-4.6-7.3-9.1c0.1-0.6,0.2-1.2,0.4-1.8 c-3.1,2.9-5.2,6.9-5.7,11.5C926.8,395.1,934.2,404.3,944.5,405.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_297_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_27_",
    className: "st13",
    d: "M858.8,470.3l-5.1,33.8c-1.2,7.8-7.7,13.4-14.6,12.3l-18.7-2.8c-5-0.8-9.1-4.9-10.2-10.5 c-1.5-7.2-2.2-14.8-2.3-22.6c13.6,1.6,27.2,0,39.6-4.8C851.3,474.3,855.2,472.4,858.8,470.3z"
  }))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_842_",
    className: "st15",
    d: "M1120.5,768.1c-0.1,0-0.1,0-0.2,0c-4.4-0.4-8.9-0.6-13.4-0.7 C1111.3,767.3,1115.8,767.6,1120.5,768.1z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    className: "st14",
    d: "M878,396.9c-1.4-0.2-2.9-0.4-4.3-0.6c-1.4-0.2-2.9-0.3-4.3-0.4c-19-1.4-37.3,2.3-38.5,12.8 c-0.9,7.9,0.5,15.5,3.7,22.2c5.9,12.4,17.9,21.6,32.6,23.3c14.7,1.6,28.4-4.7,37-15.5c4.6-5.8,7.6-12.9,8.5-20.9 C913.9,407.4,896.9,399.8,878,396.9z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_288_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_433_",
    className: "st16",
    d: "M986.9,434.8c-10.3-13.7-44.1-8.8-65.1-28c-2.3-2.1-4.5-4-6.7-5.6c-2.4-2.2-5.4-4.3-9.4-6.3 c-6.5-3.2-14.8-5.8-23.9-7.3c-2.3-0.4-4.7-0.8-7.1-1c-2.4-0.3-4.8-0.4-7.2-0.6c-9.2-0.5-17.9,0.2-24.9,1.9 c-4.3,1.1-7.8,2.5-10.6,4.1c-2.5,1.1-5,2.5-7.7,4c-24.7,14.2-56.5,1.9-69.6,13c-3.1,2.6-5.1,6.6-5.8,12.4c-0.8,7.2,0,14.2,2.1,20.8 c6.9,21.7,28.1,39,54.8,42c0.1,0,0.1,0,0.2,0c1,0.1,2,0.2,2.9,0.2c17.5,1.2,45.2-12.4,45.2-12.4s1.6-1.1,3.8-2.3 c2.4-1.3,5.4-2.5,7.7-2.3c2.2,0.3,4.9,2.2,7,3.9c1.9,1.6,3.2,3.1,3.2,3.1s24.1,19.4,41.4,22c1,0.1,1.9,0.3,2.9,0.4 c0.1,0,0.1,0,0.2,0c26.7,2.9,51.2-9.3,62.7-29c3.5-6,5.8-12.7,6.6-19.9C990.5,442.3,989.4,438.1,986.9,434.8z M904.2,438.7 c-8.5,10.8-22.3,17.1-37,15.5c-14.7-1.6-26.7-10.8-32.6-23.3c-3.2-6.7-4.6-14.3-3.7-22.2c1.2-10.5,19.5-14.1,38.5-12.8 c1.4,0.1,2.9,0.2,4.3,0.4c1.4,0.2,2.9,0.4,4.3,0.6c18.8,2.8,35.9,10.4,34.7,20.9C911.9,425.8,908.8,432.9,904.2,438.7z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M784.9,565.9C784.9,565.9,784.9,565.9,784.9,565.9C784.9,565.9,784.9,565.9,784.9,565.9 c-1.1-0.2-2.1-0.3-3.2-0.4c-91.6-13-80.3-40.2-80.3-40.2l1.4-51.3c0,0-74.9,41.8-36.4,123.7c21.3,45.3,73.6,67.1,97.5,73.4 c3.4,1.3,7,2.2,10.7,2.5l0,0l0,0c1.1,0.1,2.1,0.1,3.2,0.1c24.9,0,45-24.3,45-54.3C823,592.5,806.5,570,784.9,565.9z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 810.5,
    cy: 257.1,
    r: 19.2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 1093,
    cy: 294,
    r: 22.5
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: -131.3426,
    y1: 797.8958,
    x2: -96.2934,
    y2: 797.8958,
    gradientTransform: "matrix(1.1568 0.3571 -0.295 0.9555 866.4525 -13.768)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M519.7,714.2c-1.4,4.6-11.7,5.6-22.9,2.1c-11.2-3.5-19.1-10-17.7-14.6c1.4-4.6,11.7-5.6,22.9-2.1 S521.1,709.6,519.7,714.2z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.295 -0.9555 0.9555 0.295 -324.3822 976.2881)",
    className: "st8",
    cx: 499.4,
    cy: 708,
    rx: 12,
    ry: 24.1
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M499.2,710.7c-0.9,0-1.6-0.7-1.7-1.6c-7.1-223.6,7.6-499.5,7.7-501.8c0.1-0.9,0.8-1.6,1.8-1.6 c0.9,0.1,1.6,0.9,1.6,1.8c-0.1,2.4-14.8,278.1-7.7,501.5C500.9,709.9,500.2,710.7,499.2,710.7 C499.3,710.7,499.3,710.7,499.2,710.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M499.2,711.3c-1.2,0-2.2-1-2.2-2.2c-7.1-223.7,7.6-499.5,7.7-501.9c0.1-1.2,1.1-2.2,2.4-2.1 c0.6,0,1.2,0.3,1.5,0.8c0.4,0.5,0.6,1,0.6,1.6c-0.1,2.4-14.8,277.8-7.7,501.5c0,0.6-0.2,1.2-0.6,1.6 C500.5,711,499.9,711.3,499.2,711.3L499.2,711.3z M507,206.3c-0.6,0-1.1,0.4-1.1,1c-0.1,2.4-14.8,278.2-7.7,501.8 c0,0.6,0.5,1.1,1.1,1.1v0.6l0-0.6c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8c-7.1-223.7,7.6-499.2,7.7-501.6 c0-0.3-0.1-0.6-0.3-0.8C507.6,206.4,507.3,206.3,507,206.3C507,206.3,507,206.3,507,206.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M850.5,646.3c-1.7,0-3.3-0.9-4.1-2.5c-0.5-1-54.4-99.3-100.9-166.4c-5.4,0.9-14.6,0.2-15.9-0.4 c-1.3-0.6-4.5-5.9-3.3-6c10-0.8,13.5-1.8,12.3-3.5c-49.4-70-121.6-159.7-215.2-242.6c-0.9-0.8-12.9,1.9-15.3,0.4 c-2.3-1.6-5.2-5.5-2.9-5.9c2.1-0.3,11.4-0.7,9.8-2.1c-7.9-6.8-18.4-15.4-26.5-22.1c-2-1.6-2.3-4.5-0.6-6.5 c1.6-2,4.5-2.3,6.5-0.6c56.6,46.3,107.8,97.6,150.3,145.6c1.6,1.8,5.1-3.5,6.6-13c0.2-1.4,5,0.4,5,2.5c0,3.8-2.4,14.5-4,19.2 C772,479.5,853.8,638,854.6,639.6c1.2,2.3,0.3,5-2,6.2C852,646.1,851.2,646.3,850.5,646.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M850.5,647.1c-2.1,0-3.9-1.1-4.9-3c-0.4-0.8-54.3-99-100.6-165.9c-5.6,0.8-14.4,0.1-15.9-0.6 c-1.4-0.6-4.3-5.1-4.1-6.7c0.1-0.6,0.5-0.9,1-1c10-0.8,11.5-1.8,11.7-2.1c-64.9-92-137.2-173.5-215.2-242.5 c-0.4-0.1-2.8,0.2-4.8,0.5c-5.1,0.6-8.9,1-10.4,0c-1.7-1.1-4.5-4.2-4.1-6.1c0.2-0.7,0.7-1.2,1.6-1.3c0.5-0.1,1.4-0.2,2.5-0.3 c1.7-0.1,4.8-0.4,6.3-0.8c-7.7-6.7-17.7-14.8-25.8-21.4l-0.2-0.1c-2.3-1.9-2.7-5.4-0.8-7.7c1.9-2.3,5.4-2.7,7.7-0.8 c51.4,42.1,102,91.1,150.4,145.7c0.8,0.2,3.7-3.6,5.1-12.5c0.1-0.6,0.7-1.3,1.9-1.2c1.7,0.1,4.7,1.7,4.7,3.8 c0,3.9-2.3,14.1-3.8,19c120,137.5,201.5,295.6,202.3,297.2c1.4,2.7,0.3,6-2.4,7.4C852.3,646.9,851.4,647.1,850.5,647.1z  M745.9,476.4l0.3,0.5c46.5,67.1,100.6,165.7,101,166.5c0.9,1.8,3.2,2.6,5,1.6c1.8-0.9,2.6-3.2,1.6-5 c-0.8-1.6-82.4-159.8-202.4-297.2l-0.3-0.4l0.2-0.5c1.6-4.9,3.9-15.3,3.9-18.9c0-0.3-0.4-0.8-0.9-1.2c-0.9-0.6-1.9-0.9-2.3-0.9 c0,0,0,0,0,0c-1.2,7.3-3.7,13-6.1,13.7c-0.7,0.2-1.4,0-1.9-0.5c-48.3-54.5-98.9-103.5-150.2-145.5c-1.6-1.3-4-1.1-5.3,0.5 c-1.3,1.6-1.1,4,0.5,5.3l0.2,0.1c8.3,6.8,18.6,15.2,26.4,21.9c0.6,0.5,0.5,1.1,0.4,1.3c-0.4,1.1-2.4,1.5-8.2,2 c-1,0.1-1.9,0.2-2.4,0.2c-0.3,0.5,1.2,3,3.2,4.3c1.1,0.7,6.2,0.1,9.2-0.2c4.3-0.5,5.5-0.6,6.1,0 c78,69.1,150.5,150.7,215.4,242.7c0.6,0.8,0.4,1.4,0.2,1.8c-0.6,1.3-3,2.3-12.6,3.1c0.4,1.3,2.3,4.1,3,4.4 c1.1,0.5,10.1,1.3,15.5,0.4L745.9,476.4z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M513.4,210.9c-7.7-6.7-18-15.1-26.1-21.7c-1.1,1.9-0.7,4.4,1,5.9c6.4,5.2,14.1,11.5,21,17.3 C512,212.1,514.3,211.7,513.4,210.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M650.6,335.9c0.8,1,1.7,1.9,2.5,2.9c1.4-5.2,3-12.7,3-15.8c0-0.9-0.9-1.7-1.9-2.2 C653.4,325.6,651.8,332.4,650.6,335.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M854.6,639.6c-0.1-0.1-0.5-1-1.3-2.5c-0.4,1-1.1,1.9-2.2,2.5c-0.7,0.3-1.4,0.5-2.1,0.5 c-1.7,0-3.3-0.9-4.1-2.5c-0.5-1-54.4-99.3-100.9-166.4c-5.1,0.9-13.6,0.2-15.6-0.3c-0.7,0.1-1.4,0.1-2.1,0.2 c-1.2,0.1,2,5.4,3.3,6c1.3,0.6,10.5,1.3,15.9,0.4c46.5,67.1,100.4,165.4,100.9,166.4c0.8,1.6,2.4,2.5,4.1,2.5 c0.7,0,1.4-0.2,2.1-0.5C854.9,644.6,855.8,641.8,854.6,639.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M737.1,461.1c-49.4-70-121.6-159.7-215.2-242.6c-0.9-0.8-11.9,1.7-14.9,0.5c-0.7,0.1-1.4,0.1-1.7,0.2 c-2.3,0.4,0.5,4.4,2.9,5.9c2.3,1.6,14.3-1.2,15.3-0.4C615,306,686.2,393.7,735.5,463.1C737.1,462.6,737.6,461.9,737.1,461.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M500.8,208.8c-0.6,0-1.1-0.3-1.4-0.9c-0.3-0.8,0-1.6,0.7-2c6.4-2.9,5.7-8.2,5.7-8.4 c-0.1-0.8,0.4-1.6,1.2-1.7c0.8-0.1,1.6,0.4,1.7,1.2c0.4,2.7-0.5,8.5-7.4,11.6C501.2,208.7,501,208.8,500.8,208.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M500.8,209.4c-0.8,0-1.6-0.5-1.9-1.2c-0.5-1,0-2.3,1-2.7c6.1-2.8,5.3-7.7,5.3-7.8 c-0.2-1.1,0.6-2.2,1.7-2.4c1.1-0.2,2.2,0.6,2.4,1.7c0.5,2.8-0.5,9-7.7,12.2C501.4,209.3,501.1,209.4,500.8,209.4z M507.3,196.4 c0,0-0.1,0-0.1,0c-0.5,0.1-0.8,0.6-0.8,1.1c0,0,0.9,5.9-6,9c-0.5,0.2-0.7,0.8-0.5,1.2c0.2,0.4,0.8,0.7,1.2,0.5 c6.5-3,7.5-8.5,7-11C508.2,196.7,507.8,196.4,507.3,196.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M503.6,211.5c-0.6,0-1.1-0.3-1.4-0.9c-0.3-0.8,0-1.6,0.7-2c6.4-2.9,5.7-8.2,5.7-8.4 c-0.1-0.8,0.4-1.6,1.2-1.7c0.8-0.1,1.6,0.4,1.7,1.2c0.4,2.7-0.5,8.5-7.4,11.6C504.1,211.4,503.9,211.5,503.6,211.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M503.6,212c-0.8,0-1.6-0.5-1.9-1.2c-0.5-1,0-2.3,1-2.7c6.1-2.8,5.3-7.7,5.3-7.8c-0.2-1.1,0.6-2.2,1.7-2.4 c1.1-0.2,2.2,0.6,2.4,1.7c0.5,2.8-0.5,9-7.7,12.2C504.2,212,503.9,212,503.6,212z M510.2,199c0,0-0.1,0-0.1,0 c-0.5,0.1-0.8,0.6-0.8,1.1c0,0.2,0.9,5.9-6,9c-0.5,0.2-0.7,0.8-0.5,1.2c0.2,0.4,0.8,0.7,1.2,0.5c6.5-3,7.5-8.5,7.1-11 C511,199.4,510.6,199,510.2,199z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M506.9,213.9c-0.6,0-1.1-0.3-1.4-0.9c-0.3-0.8,0-1.6,0.7-2c6.5-3,5.7-8.3,5.7-8.4 c-0.1-0.8,0.4-1.6,1.2-1.7c0.8-0.1,1.6,0.4,1.7,1.2c0.4,2.7-0.5,8.5-7.4,11.6C507.3,213.8,507.1,213.9,506.9,213.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M506.9,214.4c-0.8,0-1.6-0.5-1.9-1.2c-0.5-1,0-2.3,1-2.7c6-2.7,5.4-7.6,5.3-7.8c-0.1-0.5,0-1.1,0.4-1.5 c0.3-0.4,0.8-0.7,1.3-0.8c0.5-0.1,1.1,0,1.5,0.3c0.5,0.3,0.8,0.8,0.9,1.4c0.5,2.8-0.5,9-7.7,12.2 C507.5,214.4,507.2,214.4,506.9,214.4z M513.5,201.5c-0.1,0-0.1,0-0.2,0c-0.3,0-0.5,0.2-0.6,0.4c-0.1,0.2-0.2,0.4-0.2,0.7 c0,0.1,0.9,5.9-6,9c-0.5,0.2-0.7,0.8-0.5,1.2c0.2,0.4,0.8,0.7,1.2,0.5c6.5-3,7.5-8.5,7.1-11c0-0.2-0.2-0.5-0.4-0.6 C513.8,201.5,513.6,201.5,513.5,201.5z"
  })))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M516.1,685.5c0,0,20.6,2.8,25.9,25.9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M485.9,734.8c0,0,13.8,9.4,30.3,3.1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M456.6,694.4c0,0-2-20.7,27.3-19.3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M550.5,691.1c0,0,32.1,19.7,18.8,49"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M499.4,756.9c0,0,13.6,7.1,35.4-7.6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M443.4,671.4c0,0,10.1-26,43.3-18.4"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_14_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st0",
    d: "M885.4,582.3c0,0,0.1,0,0.2,0c0,0,0.1,0,0.2,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0l-0.1,0l0,0l0.1,0 c0.2,0,0.4,0.1,0.6,0.1c1,0.2,2.7,0.5,5.2,0.8c2.4,0.3,5.6,0.7,9.3,0.9c3.7,0.3,8,0.4,12.7,0.5c4.7,0,9.9,0,15.4-0.4 c1.4,0,2.7-0.2,4.1-0.3c1.4-0.1,2.8-0.2,4.3-0.3c2.9-0.3,5.8-0.6,8.7-1c1.5-0.2,3-0.4,4.5-0.6c1.5-0.3,3-0.5,4.5-0.8 c3-0.5,6-1.2,9.1-1.8c1.5-0.3,3-0.7,4.6-1.1c1.5-0.4,3.1-0.7,4.6-1.1c1.5-0.4,3-0.8,4.6-1.3l2.3-0.6l2.2-0.7l4.5-1.4 c1.5-0.5,3-1.1,4.4-1.6c1.5-0.5,2.9-1.1,4.4-1.6c1.4-0.6,2.9-1.2,4.3-1.8c1.4-0.6,2.9-1.1,4.3-1.8c1.4-0.6,2.8-1.3,4.2-1.9 c2.8-1.2,5.4-2.6,8.1-3.9c1.3-0.7,2.6-1.3,3.9-2c1.3-0.7,2.5-1.4,3.7-2.1c1.2-0.7,2.5-1.4,3.7-2.1c1.2-0.7,2.3-1.5,3.5-2.2 c4.7-2.8,8.8-5.8,12.7-8.5c1.9-1.4,3.7-2.8,5.4-4.2c0.9-0.7,1.7-1.3,2.5-1.9c0.8-0.7,1.6-1.3,2.3-1.9c1.5-1.2,2.9-2.4,4.2-3.5 c0.6-0.5,1.3-1.1,1.9-1.6c0.6-0.5,1.1-1,1.6-1.5c4.1-3.8,6.5-6,6.5-6l2.1-1.9c21.3-19.6,55.3-19.1,75.9,1.2 c20.1,19.8,20,51.2,0.1,70.9c0,0-3.3,3.3-9.1,9c-0.7,0.7-1.5,1.5-2.3,2.3c-0.8,0.8-1.7,1.6-2.6,2.4c-1.8,1.7-3.8,3.4-5.9,5.4 c-1.1,0.9-2.2,1.9-3.3,2.9c-1.2,1-2.4,2-3.6,3c-2.5,2-5.1,4.2-7.9,6.4c-5.7,4.3-11.8,9-18.7,13.5c-1.7,1.1-3.4,2.3-5.2,3.5 c-1.8,1.1-3.6,2.2-5.5,3.4c-1.8,1.1-3.7,2.3-5.6,3.4c-1.9,1.2-3.9,2.2-5.8,3.3c-3.9,2.2-7.9,4.5-12.1,6.5c-2.1,1-4.2,2.1-6.3,3.1 c-2.1,1.1-4.3,2-6.5,3c-2.2,1-4.4,2-6.5,2.9c-2.2,0.9-4.5,1.8-6.7,2.7c-2.2,0.9-4.5,1.8-6.7,2.7l-6.8,2.5l-3.4,1.2l-3.5,1.1 c-2.3,0.7-4.6,1.5-6.9,2.2c-2.3,0.7-4.6,1.3-7,2c-2.3,0.6-4.6,1.3-6.9,1.9c-4.6,1.1-9.2,2.3-13.8,3.2c-2.3,0.5-4.6,0.9-6.8,1.4 c-2.3,0.4-4.5,0.8-6.8,1.2c-4.5,0.8-8.9,1.4-13.3,2c-2.2,0.3-4.3,0.5-6.5,0.8c-2.1,0.2-4.2,0.5-6.3,0.7c-8.3,0.8-16.2,1.2-23.6,1.4 c-7.4,0.1-14.1,0.1-20.2-0.1c-6.1-0.2-11.4-0.6-16-1c-4.5-0.4-8.3-0.9-11-1.3c-0.7-0.1-1.3-0.2-1.9-0.3c-0.8-0.1-1.4-0.2-1.9-0.3 c-0.8-0.1-1.2-0.2-1.2-0.2c-31.7-5.5-52.7-34.3-46.9-64.4c5.7-30.1,36-50.1,67.7-44.7c0.6,0.1,1.1,0.2,1.6,0.3L885.4,582.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 1077.6417,
    y1: 521.8937,
    x2: 1256.3273,
    y2: 521.8937
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M1077.6,577.6c0,11,4.3,18.4,11.1,21.2l24.2,10.3c2.9-0.7-6.2-11.7-2.9-13.5l98.9-57.1 c17.9-10.3,32.4-35.1,32.4-55.3c0-5.3,16.7-6.6,14.9-10.2l-21.4-8.1c-5.7-5.3-14.8-5.8-25-0.2c-0.8-8.4,12-12.2,8-17.2l-26.5-11.9 c-8.7-2.3-21.6-0.5-33.2,6.2c-27,15.6-49.1,51.6-51.7,82.8C1090.2,536.1,1077.6,558.8,1077.6,577.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1103.1,588.5c0,20.2,14.5,28.3,32.4,17.9l98.9-57.1c17.9-10.3,32.4-35.1,32.4-55.3c0-19.9-14-28-31.5-18.5 c-2.7-28-24.9-38.3-51.7-22.8c-27,15.6-49.1,51.6-51.7,82.8C1115.6,546.9,1103.1,569.7,1103.1,588.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShineInTechPond);
export default __webpack_public_path__ + "static/media/Shine-in-tech-pond.c96c07fe868939a8d8316e169d2a8ca7.svg";
export { ForwardRef as ReactComponent };